import React, { useEffect } from "react";
import { Button, Container, Link, PostCard } from "components";
import { useRecentPosts } from "hooks";
import { BackgroundColourEnum, ContainerSpacingEnum, ContainerWidthEnum } from "utils";
import { FeaturedPostsQueryFragment } from "codegen";
import "./FeaturedPosts.scss";
import AOS from "aos";
import "aos/dist/aos.css";

interface FeaturedPostsProps {
  data: FeaturedPostsQueryFragment;
  location: unknown;
}

export const FeaturedPosts = ({ data }: FeaturedPostsProps): JSX.Element => {
  const {
    feedContent = "",
    feedTitle = "",
    feedItems = [],
    feedType = "post",
    backgroundColour,
    containerWidth,
    containerSpacing,
    sectionId,
  } = data;

  let posts = feedItems;

  // If there isn't any posts selected in WP
  // Select the most recent (amount can be set in the hook)
  if (!feedItems) {
    posts = useRecentPosts(feedType);
  }

  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <Container
      className="featured-posts"
      backgroundColour={BackgroundColourEnum[backgroundColour]}
      containerWidth={ContainerWidthEnum[containerWidth]}
      containerSpacing={ContainerSpacingEnum[containerSpacing]}
      sectionId={sectionId}
    >
      {feedTitle && (
        <div className="featured-posts__title" data-aos="fade-up">
          <h2 dangerouslySetInnerHTML={{ __html: feedTitle }}></h2>
        </div>
      )}
      <div className="featured-posts__items" data-aos="fade-up">
        {Object.keys(posts).length > 0 &&
          posts?.map((item, index) => {
            return <PostCard item={item} key={`${item.id}-${index}`} />;
          })}
      </div>
      <div className="featured-posts__view-all" data-aos="fade-up">
        <Link to={feedType === "project" ? "/project-gallery/" : "/blog/"}>
          <Button variant="outline" colorScheme="secondary" rightIcon="ArrowLink">
            View more projects
          </Button>
        </Link>
      </div>
    </Container>
  );
};
